import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 4,
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '3rem', color: 'error.main', mb: 2 }}>
        403
      </Typography>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Unauthorized Access
      </Typography>
      <Typography sx={{ mb: 4, color: 'text.secondary' }}>
        You don't have permission to access this page.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default UnauthorizedPage;
